import React, { useState, useEffect } from "react";
import FooterModule from "./template/FHFooter";
import axios from "axios";
import { useStores } from "./core/src/stores";

const FHFooter = () => {
	const [footerData, setFooterData] = useState({});
	const { uiStore } = useStores();

	// Api for header
	const getFooterData = async (type, country) => {
		const endpoint = process.env.REACT_APP_CMS_MODULE_URL;

		return await axios.get(`${endpoint}section?type=${type}&country=${country}`).then((res) => res);
	};
	useEffect(() => {
		async function fetchData() {
			const resultFooter = await getFooterData("footer", uiStore.site ? uiStore.site : "uk");

			setFooterData(resultFooter.data.data.content);
		}
		fetchData();
	}, []);

	return <FooterModule {...footerData}></FooterModule>;
};

export default FHFooter;
